
<div class="mx-auto max-w-7xl px-4 py-5 sm:px-6 lg:px-8">
  <div class="relative w-80 h-80 sm:w-128 sm:h-128 m-auto mt-8">
    <img src="assets/bg_loader.png" class="w-full h-full object-contain" />
    <img src="assets/sat_loader.png" class="absolute inset-0 w-full h-full object-contain animate-spin" />
  </div>
</div>
